import { ColumnElement } from '@atoms/columnElement';
import { LocalFormatSelector } from '@atoms/localFormatSelector/localFormatSelector';
import { SwitchV2 } from '@atoms/switch';
import { EditorOptions } from '@library/tableEditor/shared/editor.options';
import type { AtomModel } from '@models/atom.model';
import type { TableEditorNumberColumnData } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';

type Props = {
  atom: AtomModel<TableEditorNumberColumnData>;
};

export const NumberEditor = observer(({ atom }: Props) => (
  <EditorOptions
    atomId={atom.id}
    onPlaceholderChange={value =>
      (atom.data.editorOptions.editors.number.placeholder = value)
    }
    placeholder={atom.data.editorOptions.editors.number.placeholder}
  >
    <ColumnElement>
      <LocalFormatSelector
        id={atom.id}
        onLocaleChange={v =>
          (atom.data.editorOptions.editors.number.format.locale = v)
        }
        selectedLocale={atom.data.editorOptions.editors.number.format.locale}
      />
    </ColumnElement>
    <ColumnElement>
      <SwitchV2
        checked={atom.data.editorOptions.editors.number.saveFormatted}
        id={`save-formatted-${atom.id}`}
        labelText="Save the formatted value"
        onCheckedChange={v =>
          (atom.data.editorOptions.editors.number.saveFormatted = v)
        }
      />
    </ColumnElement>
  </EditorOptions>
));
